(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
  function loadProductRecommendationsIntoSection() {
    var productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection === null) {
      return;
    };
    var productId = productRecommendationsSection.dataset.productId;
    var limit = productRecommendationsSection.dataset.limit;
    var requestUrl = Station.Theme.shop.root + 'recommendations/products?section_id=product-recommendations&limit='+limit+'&product_id=' + productId;
    var request = new XMLHttpRequest();
    request.open('GET', requestUrl);
    request.onload = function () {
  if (request.status >= 200 && request.status < 300) {
    var container = document.createElement('div');
    container.innerHTML = request.response;
    productRecommendationsSection.parentElement.innerHTML = container.querySelector('.product-recommendations').innerHTML;

    // Reinitialize Shopify & custom scripts
    window.Station.Theme.Currency.init();
    window.Station.Theme.Cart.init();

    // Re-run shade picker and add-to-cart functionality
    document.querySelectorAll(".shade-button").forEach(button => {
      button.addEventListener("click", function () {
        let productId = this.id.replace("shade-button-", "");
        toggleShadeDropdown(productId);
      });
    });

    document.querySelectorAll(".shade-option").forEach(option => {
      option.addEventListener("click", function () {
        let productId = this.closest(".shade-picker").querySelector(".shade-button").id.replace("shade-button-", "");
        let shadeName = this.getAttribute("data-shade-name");
        let variantId = this.getAttribute("data-variant-id");
        let swatchColor = this.getAttribute("data-swatch-color");
        selectShade(productId, shadeName, variantId, swatchColor);
      });
    });
  };
};

    request.send();
  };
  document.addEventListener('DOMContentLoaded', function (event) {
    loadProductRecommendationsIntoSection();
  });
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'product-recommendations') {
      loadProductRecommendationsIntoSection();
    };
  });

  } catch(e) { console.error(e); }
})();
})();
